"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PosaTemplate_1 = __importDefault(require("./PosaTemplate"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const epic_react_common_1 = require("epic-react-common");
const StepsSliderStyled_1 = __importDefault(require("./StepsSliderStyled"));
const StepsSlider = ({ data }) => {
    const { slide, subtitle, title } = data;
    if (!slide || !slide.length)
        return null;
    const options = {
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false
    };
    const carouselItems = slide.map(({ image, tips }, index) => {
        return (react_1.default.createElement("li", { key: index },
            react_1.default.createElement("img", { src: image, alt: `step-${index}` }),
            react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, string: tips })));
    });
    return (react_1.default.createElement(StepsSliderStyled_1.default, { className: "ecr-steps-slider" },
        react_1.default.createElement("div", { className: "ecr-slider-wrapper" },
            title ? react_1.default.createElement("h1", null, title) : null,
            subtitle ? react_1.default.createElement("h3", null, subtitle) : null,
            react_1.default.createElement(epic_react_common_1.SlickWrapper, { options: options }, carouselItems))));
};
StepsSlider.propTypes = {
    data: prop_types_1.default.object
};
exports.default = StepsSlider;
//# sourceMappingURL=StepsSlider.js.map